const { detect } = require('detect-browser');
const browser = detect();

// handle the case where we don't detect the browser
if (browser.name == 'ie' && browser.version.indexOf('11') == 0) {	
  var body = document.querySelector("html");
  body.className += " ie";
  // add style tag on head with ie overwrites
  createLinkTag();
}

function createLinkTag(){
	var head = document.head || document.getElementsByTagName('head')[0];
	var ieCssUrl = '/css/ie.';
	var cdnUrl = '#{AzureCDNUrl}';
	if (cdnUrl.indexOf('AzureCDNUrl') == -1) {
		ieCssUrl = cdnUrl + '/assets' + ieCssUrl;
	}
    var link = document.createElement('link');
	link.rel = 'stylesheet';
	link.href = ieCssUrl + IECSSCHECKSUM + '.css';
	head.appendChild(link);
}


// WEBPACK FOOTER //
// ./js/browser-detect.js